export default __webpack_public_path__ + "static/media/540.b05c420c.png";